import React from 'react'
import GitHubCalendar from "react-github-calendar";
const Statistics = () => {
  return (
    <div name="Statistics" 
         className='w-full h-screen bg-slate-800 text-slate-200 pt-24'>
             <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-fit'>
              <div className="pb-8">
                <p className='text-4xl font-bold inline border-b-4 border-amber-500'>
                  Statistics
                </p>
              </div>
             </div> 
             <p className=' text-amber-500 text-2xl font-bold flex justify-center items-center mt-2' >Days I Code</p>
          <div className='max-w-screen-lg p-4 mx-auto flex justify-center items-center mt-3' data-aos="flip-left" data-aos-duration="1000">
          <GitHubCalendar
          username="supriyosamanta1997"
          color="#c084f5"
          />
          </div>
          <div className='max-w-screen-lg p-4 mx-auto md:flex justify-center items-center mt-3' data-aos="flip-right" data-aos-duration="1000">
          <p>&nbsp;<img align="left" src="https://github-readme-stats.vercel.app/api?username=supriyosamanta1997&show_icons=true&locale=en" alt="supriyosamanta1997" sizes='10%'/></p>
          <p align="center"><img align="left" src="https://github-readme-stats.vercel.app/api/top-langs?username=supriyosamanta1997&show_icons=true&locale=en&layout=compact" alt="ninja-mono1696" /></p>
          </div>
      
    </div>
  )
}

export default Statistics